import pageName from '@/components/NewUser/pageNames'

// Keep pageName.* English values for API/permission matching; map only for UI display.
const PAGE_NAME_I18N_KEYS = {
  [pageName.transactions]: 'pageNameUi.transactions',
  [pageName.report]: 'menu.report',
  [pageName.appManagement]: 'menu.appManagement',
  [pageName.finance]: 'menu.FinancialManagement',
  [pageName.merchantKyc]: 'menu.kyc',
  [pageName.userManagement]: 'menu.userManagement',
  [pageName.wayBill]: 'menu.wayBill',
  [pageName.recurring]: 'pageNameUi.recurring',
  [pageName.virtualAccount]: 'menu.virtualAccount',
  [pageName.download]: 'menu.download',
}

export function translatePageName (vm, name) {
  if (name == null || name === '') {
    return name
  }
  const key = PAGE_NAME_I18N_KEYS[name]
  return key ? vm.$t(key) : name
}
